module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_robot_call-1a9965bc6e5944ca0607e2df34aba0ae.svg";